import { api } from "@/lib/api";

let loaded = null;
let pageviews = 0;
const w = window;
const mark = (el, key) => { el.setAttribute("data-ff-track", key); return el; };
const exists = (key) => !!document.querySelector(`[data-ff-track="${key}"]`);

function addScript(src, key, where = document.head) {
  if (exists(key)) return;
  const s = mark(document.createElement("script"), key);
  s.async = true; s.src = src;
  where.appendChild(s);
}

function initGtag(ids) {
  if (!ids.length) return;
  w.dataLayer = w.dataLayer || [];
  w.gtag = w.gtag || function () { w.dataLayer.push(arguments); };
  addScript(`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ids[0])}`, "gtag-loader");
  w.gtag("js", new Date());
  ids.forEach((id) => w.gtag("config", id.split("/")[0], { send_page_view: false }));
}

function initGtm(id) {
  if (exists(`gtm:${id}`)) return;
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
  addScript(`https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(id)}`, `gtm:${id}`);
  const ns = mark(document.createElement("noscript"), `gtm-ns:${id}`);
  const fr = document.createElement("iframe");
  fr.src = `https://www.googletagmanager.com/ns.html?id=${encodeURIComponent(id)}`;
  fr.height = "0"; fr.width = "0"; fr.style.display = "none"; fr.style.visibility = "hidden";
  ns.appendChild(fr); document.body.prepend(ns);
}

function initFbq(ids) {
  if (!ids.length) return;
  if (!w.fbq) {
    const n = (w.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); });
    if (!w._fbq) w._fbq = n;
    n.push = n; n.loaded = true; n.version = "2.0"; n.queue = [];
    addScript("https://connect.facebook.net/en_US/fbevents.js", "fbq-loader");
  }
  ids.forEach((id) => w.fbq("init", id));
}

function initTiktok(ids) {
  if (!ids.length) return;
  w.TiktokAnalyticsObject = "ttq";
  const ttq = (w.ttq = w.ttq || []);
  ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"];
  ttq.setAndDefer = (t, e) => { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; };
  ttq.methods.forEach((m) => ttq.setAndDefer(ttq, m));
  ttq.instance = (t) => { const e = ttq._i[t] || []; ttq.methods.forEach((m) => ttq.setAndDefer(e, m)); return e; };
  ttq.load = (e) => {
    const u = "https://analytics.tiktok.com/i18n/pixel/events.js";
    ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = u; ttq._t = ttq._t || {}; ttq._t[e] = +new Date(); ttq._o = ttq._o || {}; ttq._o[e] = {};
    addScript(`${u}?sdkid=${encodeURIComponent(e)}&lib=ttq`, `ttq:${e}`);
  };
  ids.forEach((id) => ttq.load(id));
}

function buildNode(n) {
  const el = document.createElement(n.tag);
  Object.entries(n.attrs || {}).forEach(([k, v]) => {
    if (k === "async" || k === "defer") el[k] = true; else el.setAttribute(k, v);
  });
  (n.children || []).forEach((c) => el.appendChild(buildNode(c)));
  return el;
}

function addCustom(item) {
  const key = `custom:${item.id}`;
  if (exists(key)) return;
  item.nodes.forEach((n, i) => {
    const el = mark(buildNode(n), i === 0 ? key : `${key}:${i}`);
    if (item.kind === "custom_head") document.head.appendChild(el);
    else if (item.kind === "custom_body") document.body.prepend(el);
    else document.body.appendChild(el);
  });
}

export function loadTracking() {
  if (loaded) return loaded;
  loaded = api.get("/seo/tracking").then(({ data }) => {
    const by = (k) => data.filter((d) => d.kind === k);
    data.filter((d) => d.meta_name).forEach((d) => {
      const key = `verify:${d.id}`;
      if (exists(key)) return;
      const m = mark(document.createElement("meta"), key);
      m.setAttribute("name", d.meta_name); m.setAttribute("content", d.value);
      document.head.appendChild(m);
    });
    initGtag([...by("ga4"), ...by("google_ads")].map((d) => d.value));
    w.__ffAdsConversions = by("google_ads").map((d) => d.value).filter((v) => v.includes("/"));
    by("gtm").forEach((d) => initGtm(d.value));
    initFbq(by("meta_pixel").map((d) => d.value));
    initTiktok(by("tiktok").map((d) => d.value));
    data.filter((d) => d.nodes).forEach(addCustom);
    return data;
  }).catch(() => { loaded = null; });
  return loaded;
}

export async function trackPageView(path, title) {
  await loadTracking();
  pageviews += 1;
  if (w.gtag) w.gtag("event", "page_view", { page_path: path, page_title: title, page_location: window.location.href });
  if (w.fbq) w.fbq("track", "PageView");
  if (w.ttq?.page) w.ttq.page();
  if (w.dataLayer) w.dataLayer.push({ event: "ff_page_view", page_path: path, page_title: title, ff_pageview_index: pageviews });
}

export async function ffTrack(name, params = {}) {
  await loadTracking();
  if (w.fbq) w.fbq("track", name, params);
  if (w.ttq?.track) w.ttq.track(name, params);
  if (w.gtag) w.gtag("event", name, params);
  if (w.dataLayer) w.dataLayer.push({ event: `ff_${name}`, ...params });
  if (name === "Purchase" && w.gtag) (w.__ffAdsConversions || []).forEach((id) => w.gtag("event", "conversion", { send_to: id, value: params.value, currency: params.currency }));
}
